import { Alert } from '@mui/material';

import { translate } from '@/ui/i18n';

export function AlertMessageFormIsValidated() {
  return (
    <Alert severity="info" variant="standard">
      {translate('External.alert-form-isvalidated')}
    </Alert>
  );
}
